export var getIconSize = function getIconSize(layoutType) {
  switch (layoutType) {
    case 'tablet':
    case 'mobile':
      return 'm';
    case 'desktop':
    case 'desktopSmall':
    default:
      return 'l';
  }
};